import React from 'react';
import { Tool, type ToolArgsWithController } from '@aha-app/aha-editor-v2';
import styles from './Tools.module.css';
import AhaAnalytics from 'javascripts/analytics';

class ToolAddSnippetPromo extends Tool {
  static toolName = 'Snippet';
  static iconClass = `aha-icon aha-icon-shared-snippet`;
  static menuItemClass = styles.promo;

  static available({ controller }: ToolArgsWithController): boolean {
    if (
      window.currentAccount &&
      !window.currentAccount.hasCrossProductPromotionsEnabled
    ) {
      return false;
    }

    const provider = controller.ahaEditor.getProvider('sharedSnippet');
    return Boolean(provider && !provider.featureEnabled());
  }

  static get promoOptions() {
    const upgradeLocation = 'knowledge_toolbar_snippets_link';
    return {
      upgradeLocation,
      url: `/suite/knowledge?upgrade_location=${upgradeLocation}#snippets`,
      trackClick: {
        'Upgrade location': window.crossPromos?.[upgradeLocation],
        'Promotion type': 'Menu',
        'Promotion product': 'Knowledge',
        'Originating product': window.currentAccount?.primaryFlavor,
      },
    };
  }

  static get label() {
    return (
      <>
        {this.toolName}{' '}
        <aha-promo-try-pill
          font-sizing='small'
          pill-size='medium'
          upgrade-location={this.promoOptions.upgradeLocation}
          style={{ marginLeft: 'var(--spacer-1)' }}
        />
      </>
    );
  }

  static async action({ editor, controller }: ToolArgsWithController) {
    AhaAnalytics.track(
      'Feature-7333230212709605344',
      'User clicks promotion',
      this.promoOptions.trackClick
    );

    window.open(this.promoOptions.url, '_blank');
  }
}

export default ToolAddSnippetPromo;
